import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';

const fetchUserPromo = async (
  body: any
): Promise<{
  response?: string;
  error?: any;
}> => {
  const headers = getDefaultHeaders({ deviceId: true,effectivePlatform:true });
  const url = `${apiConfig('promoNew', 'v3')}/get_user_promos/`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body,
    headers,
  });
  if (response) {
    if (response?.data) {
      return { response: response.data?.code };
    } else return { error: {} };
  }
  if (error) {
    return { error };
  }
};

export default fetchUserPromo;
